:host {
	display: block;
}
